import React from "react";
import RecessPImage1 from "../../../Assets/Images/card1.png"; // Assuming these map to the images in the screenshot
import RecessPImage2 from "../../../Assets/Images/card2.png";
import RecessPImage3 from "../../../Assets/Images/card3.png";
import PricingBlock from "../../SchoolPrograms/ChoosePlans/PricingBlock";
import elementryFull from "../../../Assets/Images/field-day-elementry-full.png";
import elementryWhole from "../../../Assets/Images/field-day-elementry-whole.png";
import intermediateFull from "../../../Assets/Images/field-day-intermediate-full.png";
import "./chooseplans.css";

export default function ChoosePlans() {
  const plans = [
    {
      color: "rgb(18, 113, 255)",
      title: "Elementary Full Grade",
      price: "$ 3,200",
      features: [
        "Choose from a variety of activities",
        "DJ included",
        "Up to 4.5 hours of activities",
        "One-hour lunch break included",
        "8:30am-2:30pm",
        "Up to 180 students",
      ],
      image: elementryFull,
      bottomImage: RecessPImage1,
    },
    {
      color: "rgb(18, 113, 255)",
      title: "Elementary Whole School",
      price: "$ 4,000", // Matches screenshot
      features: [
        "Choose from a variety of activities",
        "DJ included",
        "Up to 4.5 hours of activities",
        "One-hour lunch break included",
        "8:30am-2:30pm",
        "Up to 300 students",
      ],
      image: elementryWhole,
      bottomImage: RecessPImage2,
    },
    {
      color: "rgb(18, 113, 255)",
      title: "Intermediate Full Grade",
      price: "$ 4,000",
      features: [
        "Choose from a variety of activities",
        "DJ included",
        "Up to 4.5 hours of activities",
        "One-hour lunch break included",
        "8:30am-2:30pm",
        "Up to 300 students",
      ],
      image: intermediateFull,
      bottomImage: RecessPImage3,
    },
  ];

  return (
    <div className="cp-wrapper">
      <div className="cp-title-box" style={{ textAlign: "center" }}>
        <h2>Choose Your Plan</h2>
      </div>

      <div className="cp-grid">
        {plans.map((plan, index) => (
          <PricingBlock
            key={index}
            title={plan.title}
            price={plan.price}
            features={plan.features}
            image={plan.image}
            color={plan.color}
            bottomImage={plan.bottomImage}
          />
        ))}
      </div>
    </div>
  );
}
